import type { ICellRendererParams } from 'ag-grid-community';
import { get } from 'lodash-es';
import { type ConfirmParam, ConfirmTypeEnum } from '../../../types/Confirm';
import { getConfirmParam } from '../../../utils/confirmUtils';
import { format, toBig } from '../../../utils/number';
import { ConfirmSynopsis, ConfirmTooltipContent } from '../../Confirm/ConfirmSynopsis';
import { Tooltip } from '../../Tooltip';
import { baseColumn } from './baseColumn';
import type { ColDefFactory, Column } from './types';
import { numericColumnComparator } from './utils';

export const confirmSynopsis: ColDefFactory<Column> = column => ({
  ...baseColumn(column),
  initialWidth: 160,
  comparator: (valueA: ConfirmParam | undefined, valueB: ConfirmParam | undefined) =>
    numericColumnComparator(valueA?.Confirm?.Rate, valueB?.Confirm?.Rate),
  valueGetter: ({ data }): ConfirmParam | undefined => {
    const confirm = getConfirmParam(column.field ? get(data, column.field) : data);
    if (confirm?.ConfirmType !== ConfirmTypeEnum.RepoConfirm) {
      return undefined;
    }
    return confirm;
  },
  valueFormatter: ({ value }: { value: ConfirmParam | undefined }) => {
    if (!value) {
      return '';
    }
    const rate = toBig(value.Confirm?.Rate)?.times(100);
    const haircut = toBig(value.Confirm?.HaircutRatio)?.times(100);
    return `Rate ${rate ? format(rate, { spec: '0.01' }) : '-'} % / Haircut ${haircut ? format(haircut, { spec: '0.01' }) : '-'} %`;
  },
  cellRenderer: ({ value }: ICellRendererParams<unknown, ConfirmParam>) =>
    value ? (
      <Tooltip tooltip={<ConfirmTooltipContent confirm={value} />} showUnderline>
        <ConfirmSynopsis confirm={value} />
      </Tooltip>
    ) : null,
});
